import { apiClient } from '../../../app/api/apiClient';
import type { DashboardSpotlight, SpotlightAccent } from '../types/dashboard.types';

const VALID_ACCENTS: readonly SpotlightAccent[] = [
  'violet',
  'teal',
  'amber',
  'rose',
  'sky',
];
const DEFAULT_ACCENT: SpotlightAccent = 'violet';

interface DashboardSpotlightDTO {
  active: boolean;
  title?: string | null;
  subtitle?: string | null;
  description?: string | null;
  image_url?: string | null;
  accent?: string | null;
  action?: {
    label: string;
    url: string;
  } | null;
}

function normalizeAccent(accent: string | null | undefined): SpotlightAccent {
  if (accent && (VALID_ACCENTS as readonly string[]).includes(accent)) {
    return accent as SpotlightAccent;
  }
  return DEFAULT_ACCENT;
}

export async function getDashboardSpotlight(): Promise<DashboardSpotlight | null> {
  const response = await apiClient.get<DashboardSpotlightDTO>(
    '/api/dashboard/spotlight'
  );

  const { data } = response;

  if (!data || !data.active) {
    return null;
  }

  return {
    active: data.active,
    title: data.title ?? '',
    subtitle: data.subtitle ?? null,
    message: data.description ?? '',
    imageUrl: data.image_url ?? null,
    accent: normalizeAccent(data.accent),
    action: data.action ?? null,
  };
}
